<template>
	<div class="container pt-6 pb-10">
		<div class="flex justify-between items-center py-2 mb-4">
			<h1 class="page-title">Setari HUB</h1>
			<div class="bg-white px-2 py-1.5 rounded flex items-center gap-2 flex-grow-0">
				<div class="w-8">
					<img class="w-full" src="@/assets/bt_logo.png" alt="">
				</div>
				<p class="mb-0">
					Curs BT Vanzare:
					<span class="bold">1 EUR = {{ curs }} RON</span>
				</p>
			</div>
		</div>

		<div class="flex flex-col md:flex-row justify-start items-start">
			<v-navigation-drawer permanent width="200" class="mr-4 flex-shrink-0">
				<v-list dense nav>
					<v-list-item link @click.prevent="changeView('materie-prima')">
						Catalog - Materie primă
					</v-list-item>
					<v-list-item link @click.prevent="changeView('setari-vanzari')">
						Prețuri vânzări mat. primă
					</v-list-item>
					<v-list-item link @click.prevent="changeView('setari-productie')">
						Prețuri servicii producție
					</v-list-item>
					<v-list-item link @click.prevent="changeView('garduri')">
						Configurator vechi RO
					</v-list-item>
					<v-list-item link @click.prevent="changeView('garduri-eu')">
						Configurator vechi EU
					</v-list-item>
					<v-list-item link @click.prevent="changeView('preturi-garduri-hub')">
						Preturi garduri HUB
					</v-list-item>
					<v-list-item link @click.prevent="changeView('accesorii-garduri')">
						Accesorii garduri
					</v-list-item>
					<v-list-item link @click.prevent="changeView('configurator-garduri')">
						Configurator nou
					</v-list-item>
					<v-list-item link @click.prevent="changeView('contracte-productie')">
						Contracte - Firme montaj
					</v-list-item>
					<v-list-item link @click.prevent="changeView('lucrari')">
						Lucrari
					</v-list-item>
					<v-list-item link @click.prevent="changeView('setari-consumabile')">
						Materiale/consumabile
					</v-list-item>
					<v-list-item v-if="user.rol == 'admin'" link @click.prevent="changeView('setari-furnizori')">
						Furnizori
					</v-list-item>
					<v-list-item v-if="['admin', 'superuser'].includes(user.rol)" link
						@click.prevent="changeView('setari-obiective')">
						Obiective
					</v-list-item>
					<v-list-item v-if="user.rol == 'admin'" link @click.prevent="changeView('setari-users')">
						Utilizatori
					</v-list-item>
					<!-- Dev only: the build that ships to hub.cuprolli.ro never renders this entry. Locally,
					     `npm run ghost` is what points it at the production database. -->
					<v-list-item v-if="isDevEnv" link @click.prevent="changeView('setari-updates')">
						<span class="text-primary">Notificari update</span>
					</v-list-item>
				</v-list>
			</v-navigation-drawer>

			<div class="flex-grow">
				<!-- Materie-prima section -->
				<div v-if="currentTab == 'materie-prima'">
					<v-tabs v-model="materiePrimaTab" class="mb-2">
						<v-tab>Materiale</v-tab>
						<v-tab>Produse</v-tab>
						<v-tab>Aliaje</v-tab>
					</v-tabs>

					<v-tabs-items v-model="materiePrimaTab">
						<v-tab-item>
							<SetariMateriale />
						</v-tab-item>
						<v-tab-item>
							<SetariProduse />
						</v-tab-item>
						<v-tab-item>
							<SetariAliaje />
						</v-tab-item>
					</v-tabs-items>
				</div>

				<!-- Vanzari section -->
				<div v-if="currentTab == 'setari-vanzari'">
					<v-tabs v-model="preturiVanzariTab" class="mb-2">
						<v-tab>Preturi pag. ofertare</v-tab>
						<v-tab>Preturi materie prima HUB</v-tab>
						<v-tab>Preturi debitare HUB</v-tab>
						<v-tab>Preturi transport HUB</v-tab>
					</v-tabs>

					<v-tabs-items v-model="preturiVanzariTab">
						<v-tab-item>
							<SetariPreturiMateriePrima />
						</v-tab-item>
						<v-tab-item>
							<SetariVanzari />
						</v-tab-item>
						<v-tab-item>
							<SetariPreturiDebitare />
						</v-tab-item>
						<v-tab-item>
							<SetariPreturiTransport />
						</v-tab-item>
					</v-tabs-items>
				</div>

				<!-- Productie section -->
				<div v-if="currentTab == 'setari-productie'">
					<v-tabs v-model="preturiProductieTab" class="mb-2">
						<v-tab>Preturi Manopera</v-tab>
						<v-tab>Preturi Vopsit</v-tab>
						<v-tab>Preturi Servicii</v-tab>
					</v-tabs>

					<v-tabs-items v-model="preturiProductieTab">
						<v-tab-item>
							<PreturiManopera />
						</v-tab-item>
						<v-tab-item>
							<PreturiVopsit />
						</v-tab-item>
						<v-tab-item>
							<PreturiServicii />
						</v-tab-item>
					</v-tabs-items>
				</div>

				<!-- Garduri section -->
				<SettingsFences v-if="currentTab == 'garduri'" />

				<!-- Garduri EU section -->
				<SettingsFencesEU v-if="currentTab == 'garduri-eu'" />

				<!-- Preturi garduri HUB section -->
				<FencePricingSettings v-if="currentTab == 'preturi-garduri-hub'" key="hubFencePricing"
					namespace="hubFencePricing" title="Preturi garduri HUB"
					description="Preturile de baza si regulile de calcul stocate in HUB. Aceeasi structura ca in configurator, dar independente de acesta." />

				<!-- Accesorii garduri section -->
				<FenceAccessoriesSettings v-if="currentTab == 'accesorii-garduri'" />

				<!-- Configurator garduri section -->
				<FencePricingSettings v-if="currentTab == 'configurator-garduri'" key="configuratorPricing"
					namespace="configuratorPricing" title="Reguli de pret Configurator Nou"
					description="Preturile de baza si regulile de calcul stocate in configuratorul nou. Modificarile se aplica imediat pentru configuratiile noi." />

				<!-- Contracte productie section -->
				<SetariContracteProductie v-if="currentTab == 'contracte-productie'" />

				<!-- Lucrari section -->
				<div v-if="currentTab == 'lucrari'">
					<v-tabs v-model="lucrariTab" class="mb-2">
						<v-tab>Oameni productie</v-tab>
						<v-tab>Oameni montaj</v-tab>
						<v-tab>Termen montaj</v-tab>
						<v-tab>Program de lucru</v-tab>
					</v-tabs>

					<v-tabs-items v-model="lucrariTab">
						<v-tab-item>
							<SetariOameni key="oameni-productie" tip="productie" />
						</v-tab-item>
						<v-tab-item>
							<SetariOameni key="oameni-montaj" tip="montaj" />
						</v-tab-item>
						<v-tab-item>
							<SetariLucrari key="termen" section="termen" />
						</v-tab-item>
						<v-tab-item>
							<SetariLucrari key="program" section="program" />
						</v-tab-item>
					</v-tabs-items>
				</div>

				<!-- Consumabile section -->
				<SetariConsumabile v-if="currentTab == 'setari-consumabile'" />

				<!-- Furnizori section -->
				<div v-if="user.rol == 'admin' && currentTab == 'setari-furnizori'">
					<SetariFurnizori />
				</div>

				<!-- Furnizori section -->
				<div v-if="['admin', 'superuser'].includes(user.rol) && currentTab == 'setari-obiective'">
					<SettingsObjectives />
				</div>

				<!-- Users section -->
				<div v-if="user.rol == 'admin' && currentTab == 'setari-users'">
					<SetariUsers />
				</div>

				<!-- Updates section - dev only, see the nav entry above -->
				<SettingsUpdates v-if="isDevEnv && currentTab == 'setari-updates'" />
			</div>
		</div>
		<!-- <pre>{{user}}</pre> -->
		<!-- <pre>{{$store.state}}</pre> -->
	</div>
</template>

<script>
import SetariUsers from "@/components/Setari/SetariUsers";
import SetariMateriale from "@/components/Setari/SetariMateriale";
import SetariVanzari from "@/components/Setari/SetariVanzari";
import SetariPreturiDebitare from "@/components/Setari/SetariPreturiDebitare";
import SetariPreturiTransport from "@/components/Setari/SetariPreturiTransport";
import SetariProduse from "@/components/Setari/SetariProduse";
import SetariAliaje from "@/components/Setari/SetariAliaje";
import PreturiManopera from "@/components/Setari/PreturiManopera";
import PreturiVopsit from "@/components/Setari/PreturiVopsit";
import PreturiServicii from "@/components/Setari/PreturiServicii";
import SetariContracteProductie from "@/components/Setari/SetariContracteProductie";
import SetariOameni from "@/components/Setari/SetariOameni";
import SetariLucrari from "@/components/Setari/SetariLucrari";
import SetariConsumabile from "@/components/Setari/SetariConsumabile";
import SetariFurnizori from "@/components/Setari/SetariFurnizori";
import SetariPreturiMateriePrima from '@/components/Setari/SetariPreturiMateriePrima';
import SettingsObjectives from "./SettingsObjectives.vue";
import SettingsFences from "./SettingsFences.vue";
import SettingsFencesEU from "./SettingsFencesEU.vue";
import FencePricingSettings from "./FencePricingSettings.vue";
import FenceAccessoriesSettings from "./FenceAccessoriesSettings.vue";
import SettingsUpdates from "./SettingsUpdates.vue";

export default {
	name: "Setari",
	data() {
		return {
			currentTab: "materie-prima",
			materiePrimaTab: "",
			preturiVanzariTab: "",
			preturiProductieTab: "",
			lucrariTab: ""
		};
	},
	computed: {
		loading() {
			return this.$store.getters.loading;
		},
		curs() {
			return this.$store.getters.curs;
		},
		user() {
			return this.$store.getters.loggedUser;
		},
		/**
		 * Local server only - `npm run dev` and `npm run ghost` both build with NODE_ENV
		 * development, while the deployed build is production. Ghost is how the local app reaches
		 * the production database, so this stays true there too.
		 */
		isDevEnv() {
			return process.env.NODE_ENV !== "production";
		}
	},
	components: {
		SetariUsers,
		SetariMateriale,
		SetariVanzari,
		SetariPreturiDebitare,
		SetariPreturiTransport,
		SetariProduse,
		SetariAliaje,
		PreturiManopera,
		PreturiVopsit,
		PreturiServicii,
		SetariContracteProductie,
		SetariOameni,
		SetariLucrari,
		SetariConsumabile,
		SetariFurnizori,
		SettingsObjectives,
		SettingsFences,
		SettingsFencesEU,
		FencePricingSettings,
		FenceAccessoriesSettings,
		SettingsUpdates,
		SetariPreturiMateriePrima
	},
	methods: {
		changeView(tab) {
			this.currentTab = tab;
		},
		fetchCurrency() {
			this.$store.dispatch("fetchCurrency");
		},
	},
	created: function () {
		this.fetchCurrency();
	},
	updated: function () {
		M.Tabs.init(document.querySelectorAll(".tabs"));
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.side-menu {
	padding: 15px 0;
}

.side-menu .tabs {
	height: auto;
}

.side-menu .tabs .tab {
	display: block;
	text-align: left;
	text-transform: capitalize;
}

.side-menu .tabs .tab a.active {
	background-color: #f5f5f5;
	/* border-bottom: 2px solid #26a69a; */
}
</style>
